import { StepLabel } from '@mui/material';
import styled from 'styled-components';

export const CustomStepLabel = styled(StepLabel)`
  .MuiStepLabel-label {
    color: ${({ active, completed }) => (active || completed ? '#8CB4C7' : '#9e9e9e')};
    &.Mui-active {
      color: #8cb4c7;
    }
    &.Mui-completed {
      color: #8cb4c7;
    }
  }
`;
